"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimulitasExceptionTypes = exports.SimulitasException = void 0;
const SimulitasExceptionTypes = {
  INTENDED_CREDIT_NOT_IN_RANGE_FOR_HOMEREFIN: 'INTENDED_CREDIT_NOT_IN_RANGE_FOR_HOMEREFIN',
  INTENDED_CREDIT_NOT_IN_RANGE_FOR_AUTOREFIN: 'INTENDED_CREDIT_NOT_IN_RANGE_FOR_AUTOREFIN',
  INPUT_VALIDATION_ERROR: 'INPUT_VALIDATION_ERROR',
  SERVER_ERROR: 'SERVER_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR'
};
exports.SimulitasExceptionTypes = SimulitasExceptionTypes;

class SimulitasException extends Error {
  constructor(message, type) {
    super(message);
    this.type = SimulitasExceptionTypes[type];
  }

  get isOutOfRangeError() {
    return this.type === SimulitasExceptionTypes.INTENDED_CREDIT_NOT_IN_RANGE_FOR_AUTOREFIN || this.type === SimulitasExceptionTypes.INTENDED_CREDIT_NOT_IN_RANGE_FOR_HOMEREFIN;
  }

  get isUnexpectedError() {
    return this.type === SimulitasExceptionTypes.SERVER_ERROR || this.type === SimulitasExceptionTypes.UNKNOWN_ERROR || this.type === SimulitasExceptionTypes.INPUT_VALIDATION_ERROR;
  }

}

exports.SimulitasException = SimulitasException;